import { createAPI } from '../../common'
import qs from 'qs'

/**
 * 对api请求进行二次封装，注意：因在打包后会对url进行加密处理在该方法内请勿直接操作url，如需操作可引用common中decryptUrl先进行解密再操作
 * @param url
 * @param action
 * @param config
 * @param vconfig
 * @returns {*}
 */
const requestCommonAPI = function (url, action, config = {}, vconfig) {
  config = {
    ...config,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      ...config.headers
    }
  }
  if (config.headers['Content-Type'] === 'application/x-www-form-urlencoded') {
    config.data = qs.stringify(config.data)
  }
  if (config.MediaxMod) {
    config.headers.MediaxMod = config.MediaxMod
  }
  return createAPI(url, action, config, vconfig)
}
export default {
  // kpi指标
  postUserBasicTarget: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.nce0cfibwjps.bqj0vtfs0lqj0cbtjdUbshfu', 'post', config),
  postSourceKpi: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.nce0bqj0usbotnjttjpo0tpvsdf0lqj', 'post', config),
  postArticleKpi: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.nce0cfibwjps.bqj0bsujdmf0lqj', 'post', config),
  // 获取app信源列表
  postSourceList: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.nce0cfibwjps.bqj0tpvsdf0mjtu', 'post', config),
  // 成长分析-用户趋势-折线图
  postUserTotalTrend: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.nce0cfibwjps.bqj0vtfs0usfoe0vtfsUpubmUsfoe',
      'post',
      config
    ),
  // 翔宇选用---查询站点下可用栏目
  getXyColumns: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0yz0hfuDpmvnot', 'get', config),
  // 翔宇选用---查询站点
  getXySites: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0yz0hfuTjuft', 'get', config),
  // 翔宇选用---查询翔宇选用记录
  getXySelectedDocs: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0yz0hfuTfmfdufeEpdt', 'get', config),
  // 翔宇选用---翔宇编稿
  getXyEditArticle: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0yz0fejuYZBsujdmf', 'get', config),
  // 翔宇选用---选用提交
  postXyArticleSubmit: (config) =>
    requestCommonAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0yz0bsujdmfTvcnju', 'post', config),
  // 翔宇选用/采编选用--大数据稿件选用情况查询
  getDocumentRecordsList: (config) =>
    requestCommonAPI('customEncryptApiName-1/0nfejby.nce0bqj0epdvnfou0sfdpset0mjtu', 'get', config),
  // 翔宇选用/采编选用--根据ids获取多个稿件的选用记录
  getArticleRecordList: (config) =>
    requestCommonAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0bsujdmf0sfdpse0mjtu', 'get', config),
  // 采编选用----查询是否有相应的采编用户
  getEditUserInfo: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0dbjcjbo0hfuVtfsJogp', 'get', config),
  // 采编选用----查询当前稿库的文件夹树
  getEditFolders: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0dbjcjbo0hfuGpmefst', 'get', config),
  // 采编选用----查询当前稿库的文件夹 的所属人员
  getEditFolderUsers: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0dbjcjbo0hfuGpmefsVtfst', 'get', config),
  // 采编选用----查询选用记录
  getSelectedDocs: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0dbjcjbo0hfuTfmfdufeEpdt', 'get', config),
  // 采编选用----选用接口
  postArticleSubmit: (config) =>
    requestCommonAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0dbjcjbo0bsujdmfTvcnju',
      'post',
      config
    ),
  // 采编选用----选用后编稿接口
  getCreateArticle: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.nbufsjbmqbqfs0dbjcjbo0dsfbufBsujdmf', 'get', config),
  // 见报选用接口
  postRcPaperChoose: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0bsujdmf0nbufsjbmqbqfs0dipptf', 'post', config, {
      neverLoading: true
    }),
  // 本地要问选用接口
  postMbdLocalChoose: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0bsujdmf0nce0dipptf', 'post', config, {
      timeout: 90000
    }),
  postPhotoChoose: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0bsujdmf0nbufsjbmJnbhf0dipptfe', 'post', config, {
      neverLoading: true
    }),
  //评选管理作品选用
  postWorkChoose: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0bsujdmf0tfmfdujpo0xpslt0dipptf', 'post', config, {
      timeout: 90000
    })
}
